import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

/**
 * Replaces `page:search` from `@backstage/plugin-search` with a Tailwind/shadcn
 * page (ADR-0012). The stock page is a Material-UI grid with a permanent filter
 * rail that is dropped entirely on mobile, leaving no way to filter there.
 *
 * Aliasing the plugin's own route ref keeps the `/search` sidebar entry and
 * every `useRouteRef` call site pointing here.
 */
export const searchModule = createFrontendModule({
  pluginId: 'search',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/search',
        noHeader: true,
        routeRef: createRouteRef({ aliasFor: 'search.root' }),
        loader: () =>
          import('./VivictaSearchPage').then(m => (
            <PageErrorBoundary title="Search">
              <m.VivictaSearchPage />
            </PageErrorBoundary>
          )),
      },
    }),
  ],
});
